var blockSelector = ".acf-slider";
var block = document.querySelector(blockSelector);

var wrapperSelector = ".items";
var wrapper = block.querySelector(wrapperSelector);

var itemsSelector = ".items > *";
var items = block.querySelectorAll(itemsSelector);

var controls_next = block.querySelector("button[data-controls='next']");

var carouselPositions;
var halfContainer;
var currentItem;

function getCarouselPositions() {
	carouselPositions = [];
	items.forEach(function (item) {
		carouselPositions.push([item.offsetLeft, item.offsetLeft + item.clientWidth + item.width]); // add to array the positions information
		console.log(item.getBoundingClientRect());
		console.log(item.offsetLeft);
		console.log(item.width);
	});
	halfContainer = items.offsetWidth / 2;

	console.log(carouselPositions);
}

window.addEventListener("DOMContentLoaded", function (event) {
	console.log("DOM fully loaded and parsed");
	getCarouselPositions(); // call it once
});

function goCarousel(direction) {
	var currentScrollLeft = wrapper.scrollLeft;
	var currentScrollRight = currentScrollLeft + wrapper.offsetWidth;

	console.log(currentScrollLeft);
	console.log(currentScrollRight);

	if (currentScrollLeft === 0 && direction === "next") {
		currentItem = 1;
	} else if (currentScrollRight === wrapper.scrollWidth && direction === "previous") {
		console.log("here");
		currentItem = carouselPositions.length - 2;
	} else {
		var currentMiddlePosition = currentScrollLeft + halfContainer;
		for (var i = 0; i < carouselPositions.length; i++) {
			if (currentMiddlePosition > carouselPositions[i][0] && currentMiddlePosition < carouselPositions[i][1]) {
				currentItem = i;
				if (direction === "next") {
					currentItem++;
				} else if (direction === "previous") {
					currentItem--;
				}
			}
		}
	}

	wrapper.scrollTo({
		left: carouselPositions[currentItem][0],
		behavior: "smooth",
	});

	console.log(carouselPositions[currentItem][0]);
}

window.addEventListener("resize", getCarouselPositions);

controls_next.addEventListener("click", function () {
	console.log("clicked");
	goCarousel("next");
});
